module.exports = __webpack_public_path__ + "static/media/mortar.b660851c.png";